var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPenEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.652,
    height: 33.651,
    viewBox: "0 0 33.652 33.651",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1311",
    "data-name": "Group 1311",
    transform: "translate(0 2.404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1310",
    "data-name": "Group 1310"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M27.642,48.559a1.2,1.2,0,0,0-1.2,1.2V61.779a1.2,1.2,0,0,1-1.2,1.2H3.605a1.2,1.2,0,0,1-1.2-1.2V37.742a1.2,1.2,0,0,1,1.2-1.2H18.027a1.2,1.2,0,1,0,0-2.4H3.605A3.605,3.605,0,0,0,0,37.742V61.779a3.605,3.605,0,0,0,3.605,3.605H25.238a3.605,3.605,0,0,0,3.605-3.605V49.761A1.2,1.2,0,0,0,27.642,48.559Z",
    transform: "translate(0 -34.137)",
    fill: "#ed4846"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1313",
    "data-name": "Group 1313",
    transform: "translate(7.212 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1312",
    "data-name": "Group 1312"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M127.5,1.351a4.6,4.6,0,0,0-6.507,0L105.164,17.181a1.215,1.215,0,0,0-.29.47l-2.4,7.211a1.2,1.2,0,0,0,1.139,1.582,1.221,1.221,0,0,0,.38-.061l7.211-2.4a1.2,1.2,0,0,0,.47-.291L127.5,7.858A4.6,4.6,0,0,0,127.5,1.351Zm-1.7,4.808L110.178,21.783l-4.668,1.559,1.554-4.662,15.63-15.624a2.2,2.2,0,1,1,3.108,3.1Z",
    transform: "translate(-102.409 -0.004)",
    fill: "#ed4846"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenEdit);
export default __webpack_public_path__ + "static/media/penEdit.3dfcfce8957e6e795c3aced25b68df47.svg";
export { ForwardRef as ReactComponent };